{
  "schemaVersion": 1,
  "defaults": {
    "frontReceipt": {
      "templateId": "frontReceipt-58",
      "templateVersion": 1
    },
    "kitchen": {
      "templateId": "kitchen-58",
      "templateVersion": 1
    },
    "cupLabel": {
      "templateId": "cupLabel-58",
      "templateVersion": 1
    }
  },
  "templates": [
    {
      "id": "frontReceipt-58",
      "templateVersion": 1,
      "schemaVersion": 1,
      "kind": "frontReceipt",
      "name": "销售小票 · 58mm",
      "paper": {
        "widthMm": 58,
        "columns": 30,
        "feedLines": 3
      },
      "lineSpacing": 32,
      "nodes": [
        {
          "type": "text",
          "text": "{{testMark}}",
          "when": "testMark",
          "align": "center",
          "bold": true
        },
        {
          "type": "text",
          "text": "{{shopName}}",
          "align": "center",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "{{chainName}}",
          "when": "chainName",
          "align": "center"
        },
        {
          "type": "text",
          "text": "销售小票",
          "align": "center"
        },
        {
          "type": "text",
          "text": "订单号：{{orderNumber}}"
        },
        {
          "type": "text",
          "text": "时间：{{time}}"
        },
        {
          "type": "text",
          "text": "桌台：{{tableName}}",
          "when": "tableName",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "来源：{{salePoint}}",
          "when": "salePoint"
        },
        {
          "type": "text",
          "text": "履约：{{fulfillment}}",
          "when": "fulfillment"
        },
        {
          "type": "text",
          "text": "会员：{{pickupMemberName}}",
          "when": "pickupMemberName",
          "bold": true
        },
        {
          "type": "text",
          "text": "手机：****{{pickupPhoneTail}}",
          "when": "pickupPhoneTail",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "separator",
          "char": "-"
        },
        {
          "type": "repeat",
          "field": "items",
          "nodes": [
            {
              "type": "text",
              "text": "{{item.name}}",
              "bold": true
            },
            {
              "type": "text",
              "text": "{{item.specText}}",
              "when": "item.specText"
            },
            {
              "type": "text",
              "text": "备注：{{item.commit}}",
              "when": "item.commit"
            },
            {
              "type": "row",
              "cells": [
                {
                  "text": "单价 {{item.price}}",
                  "width": 11,
                  "align": "left"
                },
                {
                  "text": "×{{item.qty}}",
                  "width": 7,
                  "align": "right"
                },
                {
                  "text": "{{item.subtotal}}",
                  "width": 12,
                  "align": "right"
                }
              ]
            }
          ]
        },
        {
          "type": "separator",
          "char": "-"
        },
        {
          "type": "row",
          "cells": [
            {
              "text": "合计",
              "width": 10,
              "align": "left"
            },
            {
              "text": "¥{{amount}}",
              "width": 20,
              "align": "right"
            }
          ]
        },
        {
          "type": "text",
          "text": "支付：{{payment}}",
          "when": "payment"
        },
        {
          "type": "text",
          "text": "顾客：{{customerName}}",
          "when": "customerName"
        },
        {
          "type": "text",
          "text": "操作员：{{staffName}}",
          "when": "staffName"
        },
        {
          "type": "text",
          "text": "配送：{{deliveryName}}",
          "when": "deliveryName"
        },
        {
          "type": "text",
          "text": "联系电话：{{deliveryPhone}}",
          "when": "deliveryPhone"
        },
        {
          "type": "text",
          "text": "{{deliveryAddress}}",
          "when": "deliveryAddress"
        },
        {
          "type": "text",
          "text": "谢谢惠顾，欢迎再次光临",
          "align": "center"
        }
      ]
    },
    {
      "id": "frontReceipt-80",
      "templateVersion": 1,
      "schemaVersion": 1,
      "kind": "frontReceipt",
      "name": "销售小票 · 80mm",
      "paper": {
        "widthMm": 80,
        "columns": 46,
        "feedLines": 3
      },
      "lineSpacing": 32,
      "nodes": [
        {
          "type": "text",
          "text": "{{testMark}}",
          "when": "testMark",
          "align": "center",
          "bold": true
        },
        {
          "type": "text",
          "text": "{{shopName}}",
          "align": "center",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "{{chainName}}",
          "when": "chainName",
          "align": "center"
        },
        {
          "type": "text",
          "text": "销售小票",
          "align": "center"
        },
        {
          "type": "text",
          "text": "订单号：{{orderNumber}}"
        },
        {
          "type": "text",
          "text": "时间：{{time}}"
        },
        {
          "type": "text",
          "text": "桌台：{{tableName}}",
          "when": "tableName",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "来源：{{salePoint}}",
          "when": "salePoint"
        },
        {
          "type": "text",
          "text": "履约：{{fulfillment}}",
          "when": "fulfillment"
        },
        {
          "type": "text",
          "text": "会员：{{pickupMemberName}}",
          "when": "pickupMemberName",
          "bold": true
        },
        {
          "type": "text",
          "text": "手机：****{{pickupPhoneTail}}",
          "when": "pickupPhoneTail",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "separator",
          "char": "-"
        },
        {
          "type": "repeat",
          "field": "items",
          "nodes": [
            {
              "type": "text",
              "text": "{{item.name}}",
              "bold": true
            },
            {
              "type": "text",
              "text": "{{item.specText}}",
              "when": "item.specText"
            },
            {
              "type": "text",
              "text": "备注：{{item.commit}}",
              "when": "item.commit"
            },
            {
              "type": "row",
              "cells": [
                {
                  "text": "单价 {{item.price}}",
                  "width": 11,
                  "align": "left"
                },
                {
                  "text": "×{{item.qty}}",
                  "width": 7,
                  "align": "right"
                },
                {
                  "text": "{{item.subtotal}}",
                  "width": 12,
                  "align": "right"
                }
              ]
            }
          ]
        },
        {
          "type": "separator",
          "char": "-"
        },
        {
          "type": "row",
          "cells": [
            {
              "text": "合计",
              "width": 10,
              "align": "left"
            },
            {
              "text": "¥{{amount}}",
              "width": 20,
              "align": "right"
            }
          ]
        },
        {
          "type": "text",
          "text": "支付：{{payment}}",
          "when": "payment"
        },
        {
          "type": "text",
          "text": "顾客：{{customerName}}",
          "when": "customerName"
        },
        {
          "type": "text",
          "text": "操作员：{{staffName}}",
          "when": "staffName"
        },
        {
          "type": "text",
          "text": "配送：{{deliveryName}}",
          "when": "deliveryName"
        },
        {
          "type": "text",
          "text": "联系电话：{{deliveryPhone}}",
          "when": "deliveryPhone"
        },
        {
          "type": "text",
          "text": "{{deliveryAddress}}",
          "when": "deliveryAddress"
        },
        {
          "type": "text",
          "text": "谢谢惠顾，欢迎再次光临",
          "align": "center"
        }
      ]
    },
    {
      "id": "kitchen-58",
      "templateVersion": 1,
      "schemaVersion": 1,
      "kind": "kitchen",
      "name": "厨房单 · 58mm",
      "paper": {
        "widthMm": 58,
        "columns": 30,
        "feedLines": 3
      },
      "lineSpacing": 32,
      "nodes": [
        {
          "type": "text",
          "text": "{{testMark}}",
          "when": "testMark",
          "align": "center",
          "bold": true
        },
        {
          "type": "text",
          "text": "{{shopName}}",
          "align": "center",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "{{chainName}}",
          "when": "chainName",
          "align": "center"
        },
        {
          "type": "text",
          "text": "厨房出菜单 · {{action}}",
          "align": "center",
          "bold": true
        },
        {
          "type": "text",
          "text": "{{subject}}",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "人数：{{person}}",
          "when": "person"
        },
        {
          "type": "text",
          "text": "操作员：{{staffName}}",
          "when": "staffName"
        },
        {
          "type": "text",
          "text": "时间：{{time}}"
        },
        {
          "type": "text",
          "text": "履约：{{fulfillment}}",
          "when": "fulfillment"
        },
        {
          "type": "separator",
          "char": "-"
        },
        {
          "type": "repeat",
          "field": "items",
          "nodes": [
            {
              "type": "row",
              "heightScale": 2,
              "bold": true,
              "cells": [
                {
                  "text": "{{item.name}}",
                  "width": 24,
                  "align": "left"
                },
                {
                  "text": "×{{item.qty}}",
                  "width": 6,
                  "align": "right"
                }
              ]
            },
            {
              "type": "text",
              "text": "{{item.specText}}",
              "when": "item.specText"
            },
            {
              "type": "text",
              "text": "备注：{{item.commit}}",
              "when": "item.commit"
            },
            {
              "type": "space",
              "count": 1
            }
          ]
        },
        {
          "type": "separator",
          "char": "-"
        },
        {
          "type": "text",
          "text": "商品总数：{{totalQty}}"
        }
      ]
    },
    {
      "id": "kitchen-80",
      "templateVersion": 1,
      "schemaVersion": 1,
      "kind": "kitchen",
      "name": "厨房单 · 80mm",
      "paper": {
        "widthMm": 80,
        "columns": 46,
        "feedLines": 3
      },
      "lineSpacing": 32,
      "nodes": [
        {
          "type": "text",
          "text": "{{testMark}}",
          "when": "testMark",
          "align": "center",
          "bold": true
        },
        {
          "type": "text",
          "text": "{{shopName}}",
          "align": "center",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "{{chainName}}",
          "when": "chainName",
          "align": "center"
        },
        {
          "type": "text",
          "text": "厨房出菜单 · {{action}}",
          "align": "center",
          "bold": true
        },
        {
          "type": "text",
          "text": "{{subject}}",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "人数：{{person}}",
          "when": "person"
        },
        {
          "type": "text",
          "text": "操作员：{{staffName}}",
          "when": "staffName"
        },
        {
          "type": "text",
          "text": "时间：{{time}}"
        },
        {
          "type": "text",
          "text": "履约：{{fulfillment}}",
          "when": "fulfillment"
        },
        {
          "type": "separator",
          "char": "-"
        },
        {
          "type": "repeat",
          "field": "items",
          "nodes": [
            {
              "type": "row",
              "heightScale": 2,
              "bold": true,
              "cells": [
                {
                  "text": "{{item.name}}",
                  "width": 24,
                  "align": "left"
                },
                {
                  "text": "×{{item.qty}}",
                  "width": 6,
                  "align": "right"
                }
              ]
            },
            {
              "type": "text",
              "text": "{{item.specText}}",
              "when": "item.specText"
            },
            {
              "type": "text",
              "text": "备注：{{item.commit}}",
              "when": "item.commit"
            },
            {
              "type": "space",
              "count": 1
            }
          ]
        },
        {
          "type": "separator",
          "char": "-"
        },
        {
          "type": "text",
          "text": "商品总数：{{totalQty}}"
        }
      ]
    },
    {
      "id": "cupLabel-58",
      "templateVersion": 1,
      "schemaVersion": 1,
      "kind": "cupLabel",
      "name": "杯贴 · 58mm",
      "paper": {
        "widthMm": 58,
        "columns": 30,
        "feedLines": 1
      },
      "lineSpacing": 32,
      "nodes": [
        {
          "type": "text",
          "text": "{{testMark}}",
          "when": "testMark",
          "align": "center",
          "bold": true
        },
        {
          "type": "text",
          "text": "#{{orderNumber}}",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "{{name}}",
          "bold": true,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "{{specText}}",
          "when": "specText"
        },
        {
          "type": "text",
          "text": "备注：{{commit}}",
          "when": "commit"
        },
        {
          "type": "row",
          "cells": [
            {
              "text": "{{fulfillment}}",
              "width": 18,
              "align": "left"
            },
            {
              "text": "第{{index}}/{{total}}杯",
              "width": 12,
              "align": "right"
            }
          ]
        },
        {
          "type": "text",
          "text": "{{shopName}}",
          "align": "center"
        },
        {
          "type": "text",
          "text": "{{time}}",
          "align": "center"
        }
      ]
    },
    {
      "id": "cupLabel-80",
      "templateVersion": 1,
      "schemaVersion": 1,
      "kind": "cupLabel",
      "name": "杯贴 · 80mm",
      "paper": {
        "widthMm": 80,
        "columns": 46,
        "feedLines": 1
      },
      "lineSpacing": 32,
      "nodes": [
        {
          "type": "text",
          "text": "{{testMark}}",
          "when": "testMark",
          "align": "center",
          "bold": true
        },
        {
          "type": "text",
          "text": "#{{orderNumber}}",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "{{name}}",
          "bold": true,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "{{specText}}",
          "when": "specText"
        },
        {
          "type": "text",
          "text": "备注：{{commit}}",
          "when": "commit"
        },
        {
          "type": "row",
          "cells": [
            {
              "text": "{{fulfillment}}",
              "width": 18,
              "align": "left"
            },
            {
              "text": "第{{index}}/{{total}}杯",
              "width": 12,
              "align": "right"
            }
          ]
        },
        {
          "type": "text",
          "text": "{{shopName}}",
          "align": "center"
        },
        {
          "type": "text",
          "text": "{{time}}",
          "align": "center"
        }
      ]
    },
    {
      "id": "frontReceipt-58",
      "templateVersion": 2,
      "schemaVersion": 1,
      "kind": "frontReceipt",
      "name": "销售小票 · 58mm",
      "paper": {
        "widthMm": 58,
        "columns": 30,
        "feedLines": 3
      },
      "lineSpacing": 32,
      "nodes": [
        {
          "type": "text",
          "text": "{{testMark}}",
          "when": "testMark",
          "align": "center",
          "bold": true
        },
        {
          "type": "text",
          "text": "{{shopName}}",
          "align": "center",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "{{chainName}}",
          "when": "chainName",
          "align": "center"
        },
        {
          "type": "text",
          "text": "销售小票",
          "align": "center"
        },
        {
          "type": "text",
          "text": "订单号：{{orderNumber}}"
        },
        {
          "type": "text",
          "text": "时间：{{time}}"
        },
        {
          "type": "text",
          "text": "桌台：{{tableName}}",
          "when": "tableName",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "来源：{{salePoint}}",
          "when": "salePoint"
        },
        {
          "type": "text",
          "text": "履约：{{fulfillment}}",
          "when": "fulfillment"
        },
        {
          "type": "text",
          "text": "{{pickupMemberDisplay}}",
          "when": "pickupMemberDisplay",
          "bold": true,
          "widthScale": 1,
          "heightScale": 2
        },
        {
          "type": "separator",
          "char": "-"
        },
        {
          "type": "repeat",
          "field": "items",
          "nodes": [
            {
              "type": "text",
              "text": "{{item.name}}",
              "bold": true
            },
            {
              "type": "text",
              "text": "{{item.specText}}",
              "when": "item.specText"
            },
            {
              "type": "text",
              "text": "备注：{{item.commit}}",
              "when": "item.commit"
            },
            {
              "type": "row",
              "cells": [
                {
                  "text": "单价 {{item.price}}",
                  "width": 11,
                  "align": "left"
                },
                {
                  "text": "×{{item.qty}}",
                  "width": 7,
                  "align": "right"
                },
                {
                  "text": "{{item.subtotal}}",
                  "width": 12,
                  "align": "right"
                }
              ]
            }
          ]
        },
        {
          "type": "separator",
          "char": "-"
        },
        {
          "type": "row",
          "cells": [
            {
              "text": "合计",
              "width": 10,
              "align": "left"
            },
            {
              "text": "¥{{amount}}",
              "width": 20,
              "align": "right"
            }
          ]
        },
        {
          "type": "text",
          "text": "支付：{{payment}}",
          "when": "payment"
        },
        {
          "type": "text",
          "text": "顾客：{{customerName}}",
          "when": "customerName"
        },
        {
          "type": "text",
          "text": "操作员：{{staffName}}",
          "when": "staffName"
        },
        {
          "type": "text",
          "text": "配送：{{deliveryName}}",
          "when": "deliveryName"
        },
        {
          "type": "text",
          "text": "联系电话：{{deliveryPhone}}",
          "when": "deliveryPhone"
        },
        {
          "type": "text",
          "text": "{{deliveryAddress}}",
          "when": "deliveryAddress"
        },
        {
          "type": "text",
          "text": "谢谢惠顾，欢迎再次光临",
          "align": "center"
        }
      ]
    },
    {
      "id": "frontReceipt-80",
      "templateVersion": 2,
      "schemaVersion": 1,
      "kind": "frontReceipt",
      "name": "销售小票 · 80mm",
      "paper": {
        "widthMm": 80,
        "columns": 46,
        "feedLines": 3
      },
      "lineSpacing": 32,
      "nodes": [
        {
          "type": "text",
          "text": "{{testMark}}",
          "when": "testMark",
          "align": "center",
          "bold": true
        },
        {
          "type": "text",
          "text": "{{shopName}}",
          "align": "center",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "{{chainName}}",
          "when": "chainName",
          "align": "center"
        },
        {
          "type": "text",
          "text": "销售小票",
          "align": "center"
        },
        {
          "type": "text",
          "text": "订单号：{{orderNumber}}"
        },
        {
          "type": "text",
          "text": "时间：{{time}}"
        },
        {
          "type": "text",
          "text": "桌台：{{tableName}}",
          "when": "tableName",
          "bold": true,
          "widthScale": 2,
          "heightScale": 2
        },
        {
          "type": "text",
          "text": "来源：{{salePoint}}",
          "when": "salePoint"
        },
        {
          "type": "text",
          "text": "履约：{{fulfillment}}",
          "when": "fulfillment"
        },
        {
          "type": "text",
          "text": "{{pickupMemberDisplay}}",
          "when": "pickupMemberDisplay",
          "bold": true,
          "widthScale": 1,
          "heightScale": 2
        },
        {
          "type": "separator",
          "char": "-"
        },
        {
          "type": "repeat",
          "field": "items",
          "nodes": [
            {
              "type": "text",
              "text": "{{item.name}}",
              "bold": true
            },
            {
              "type": "text",
              "text": "{{item.specText}}",
              "when": "item.specText"
            },
            {
              "type": "text",
              "text": "备注：{{item.commit}}",
              "when": "item.commit"
            },
            {
              "type": "row",
              "cells": [
                {
                  "text": "单价 {{item.price}}",
                  "width": 11,
                  "align": "left"
                },
                {
                  "text": "×{{item.qty}}",
                  "width": 7,
                  "align": "right"
                },
                {
                  "text": "{{item.subtotal}}",
                  "width": 12,
                  "align": "right"
                }
              ]
            }
          ]
        },
        {
          "type": "separator",
          "char": "-"
        },
        {
          "type": "row",
          "cells": [
            {
              "text": "合计",
              "width": 10,
              "align": "left"
            },
            {
              "text": "¥{{amount}}",
              "width": 20,
              "align": "right"
            }
          ]
        },
        {
          "type": "text",
          "text": "支付：{{payment}}",
          "when": "payment"
        },
        {
          "type": "text",
          "text": "顾客：{{customerName}}",
          "when": "customerName"
        },
        {
          "type": "text",
          "text": "操作员：{{staffName}}",
          "when": "staffName"
        },
        {
          "type": "text",
          "text": "配送：{{deliveryName}}",
          "when": "deliveryName"
        },
        {
          "type": "text",
          "text": "联系电话：{{deliveryPhone}}",
          "when": "deliveryPhone"
        },
        {
          "type": "text",
          "text": "{{deliveryAddress}}",
          "when": "deliveryAddress"
        },
        {
          "type": "text",
          "text": "谢谢惠顾，欢迎再次光临",
          "align": "center"
        }
      ]
    }
  ]
}
